import * as mainApi from 'util/server/mainApi'

export function fetchBadges() {
  return (dispatch) => {
    return mainApi.getBadges().then((resp) => {
      dispatch({ type: 'SET_BADGES', badges: resp.data.badges })
    })
  }
}
